import { render, staticRenderFns } from "./StatusBemSelector.vue?vue&type=template&id=c48e16c8&scoped=true&"
import script from "./StatusBemSelector.vue?vue&type=script&lang=js&"
export * from "./StatusBemSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48e16c8",
  null
  
)

export default component.exports